/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const ExpertEvaluation = {

	delete (context, expertEvaluationId, onSuccess, onError, options) {
		Api.delete(context,
			"/expert-evaluation"
			+ "?expertEvaluationId=" + expertEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, expertEvaluationId, onSuccess, onError, options) {
		Api.get(context,
			"/expert-evaluation"
			+ "?expertEvaluationId=" + expertEvaluationId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/expert-evaluation/configuration"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestNames (context, onSuccess, onError, options) {
		Api.get(context,
			"/expert-evaluation/contest-names"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postContestUsers (context, offerId, contestUserIds, onSuccess, onError, options) {
		Api.post(context,
			"/expert-evaluation/contest-users"
			+ "?offerId=" + offerId
			, contestUserIds
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, expertEvaluationId, onSuccess, onError, options) {
		Api.put(context,
			"/expert-evaluation"
			+ "?expertEvaluationId=" + expertEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putCorrection (context, evaluationId, correctionCauseDTO, onSuccess, onError, options) {
		Api.put(context,
			"/expert-evaluation/correction"
			+ "?evaluationId=" + evaluationId
			, correctionCauseDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putData (context, expertEvaluationId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/expert-evaluation/data"
			+ "?expertEvaluationId=" + expertEvaluationId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, expertEvaluationId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/expert-evaluation/finish"
			+ "?expertEvaluationId=" + expertEvaluationId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
